import { render, staticRenderFns } from "./Evermart.vue?vue&type=template&id=07db0f70&"
import script from "./Evermart.vue?vue&type=script&lang=js&"
export * from "./Evermart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports